import { getLanguage } from '@/utils/common/locale'
import { is99 } from '@/utils/common/env'

const commonPassportConfig = {
  // appid: 121329, //测试环境appid，在passport test环境使用的，目前测试用的sim，暂时用不上此appid
  appid: is99 ? 200108 : 200058,// 测试环境appid，在passport test环境使用的，目前测试用的sim，暂时用不上此appid
  role: 13,
  lang: getLanguage().long,
}

// passport js地址
export const PASSPORT_JS_URL = {
  ONLINE: '//static.didiglobal.com/common-biz/global-login/2.1.7/login.global.min.js',
  TEST: '//passport-test.didichuxing.com/static/trinity-login/2.2.5/login.test.js',
}

// passport 登录信息存储在storage里的key值
export const PASSPORT_INFO_KEY = 'B_H5_PASSPORT_LOGIN_INFO'

// passport 登录后，选择的门店id
export const CURRENT_SHOP_ID_KEY = 'B_H5_CURRENT_SHOP_ID'

// passport 不同国家的配置
export const countryPassportConfig = {
  default: {
    ...commonPassportConfig,
    country_id: 484,
    country_calling_code: '+52',
  },
  MX: {
    ...commonPassportConfig,
    country_id: 484,
    country_calling_code: '+52',
  },
  JP: {
    ...commonPassportConfig,
    country_id: 392,
    country_calling_code: '+81',
  },
  CR: {
    ...commonPassportConfig,
    country_id: 188,
    country_calling_code: '+506',
  },
  CO: {
    ...commonPassportConfig,
    country_id: 170,
    country_calling_code: '+57',
  },
  CL: {
    ...commonPassportConfig,
    country_id: 152,
    country_calling_code: '+56',
  },
  PE: {
    ...commonPassportConfig,
    country_id: 604,
    country_calling_code: '+51',
  },
  DO: {
    ...commonPassportConfig,
    country_id: 604,
    country_calling_code: '+1',
  },
  BR: {
    ...commonPassportConfig,
    country_id: 76,
    country_calling_code: '+55',
    theme: 'yellow',
  },
}

export function getPassportConfig(country = 'MX') {
  const config = countryPassportConfig[country] || countryPassportConfig.default
  return config
}
